import React, { useState, useEffect } from 'react';
import { Table, Button, Space, DatePicker, Tag, Modal, Tooltip, Card, Row, Col, Input } from 'antd';
import { useSelector } from 'react-redux';
import { DeleteFilled, EditOutlined, EditTwoTone, EyeOutlined, FilterOutlined, InfoCircleOutlined, PlusCircleFilled, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { showMessage } from '../../Components/Utils/message';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import dayjs from 'dayjs';
import { Grid } from '@mui/material';
import AuthService from '../../Components/auth/AuthService';
import { encodeId } from '../../Components/common/CommonFun';
import { styled } from '@mui/system';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService()
const TransferStockList = () => {
    const { products, locations, roles, type: roleType } = useSelector((state) => state?.AppState?.userCreds);
    const [allTransfers, setAllTransfers] = useState([]);
    const firstDayOfMonth = dayjs().startOf('month');
    const lastDayOfMonth = dayjs().endOf('month');
    const [startDate, setStartDate] = useState(firstDayOfMonth);
    const [endDate, setEndDate] = useState(lastDayOfMonth);
    const navigate = useNavigate()
    const layoutDispatch = useLoadingDispatch()
    const canAccess =
        roleType === 0 ||
        roleType === 1 ||
        (roleType === 2 && roles?.some((role) => role.role_id === 4));

         const { RangePicker } = DatePicker;
        
          const [filters, setFilters] = React.useState({
            dateRange: [dayjs().startOf("month"), dayjs().endOf("month")],
            batchCode: '',
          });


    const getTransfers = async () => {
        showLoading(layoutDispatch);
        const dataToSend = {
            //   limit: limit,
            //   page: page,
            }
            if (filters?.dateRange && filters?.dateRange[0] && filters?.dateRange[1]) {
              dataToSend.start_date = dayjs(filters?.dateRange[0]).format("YYYY-MM-DD");
              dataToSend.end_date = dayjs(filters?.dateRange[1]).format("YYYY-MM-DD");
            }
        try {
            const res = await Auth.post(`/stock/all-transfer-stocks`, dataToSend);
            if (res?.ack) {

                setAllTransfers(res?.transfer_stocks || []);
            } else {
                setAllTransfers([]);
                showMessage('error', res?.message);
            }

        } catch (err) {
            console.log(err);
            showMessage('error', 'Something went wrong while fetching ');
            setAllTransfers([]);
        }
        finally {
            hideLoading(layoutDispatch);
        }
    }

    useEffect(() => {
        getTransfers();
    }, [filters?.dateRange]);

    const columns = [


        {
            title: 'Code',
            width: 120,
            render: (record) => {
                return (
                    <span>{record?.transfer_stock_code || ''}</span>
                );
            }
        },
        {
            title: 'Product',
            width: 200,
            render: (record) => {
                const product = products?.find(pro => pro?.netsuite_id == record?.product_netsuite_id);
                return (
                    <Tooltip title={product?.name}>
                        <span
                            style={{
                                maxWidth: 200,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'inline-block',
                            }}
                        >
                            {`${product?.code} - ${product?.name}`}

                        </span>
                    </Tooltip>
                );
            }
        },
        {
            title: 'Source Location',
            width: 120,
            render: (record) => {
                const source = locations?.find(loc => loc?.id === record?.source_location_id);
                return (
                    <span>{`${source?.code}`}</span>
                );
            }
        },
        
        {
            title: 'Destination Location',
            width: 160,
            render: (record) => {
                const source = locations?.find(loc => loc?.id === record?.dest_location_id);
                return (
                    <span>{`${source?.code}`}</span>
                );
            }
        },
        {
            title: 'Quantity',
            width: 100,
            render: (record) => {
                return (
                    <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.quantity)?.toLocaleString() || 0} </Tag>
                    
                );
            }
        },
        {
            title: "User",
            width: 150,
            render(record) {
                if (!record) return "";

                const user = record?.user_name || "";
                const helper = record?.helper_name || "";

                if (helper) {
                    return (
                        <>
                            {helper}{" "}
                            {user && (
                                <Tooltip title={`${user}`}>
                                    <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                                </Tooltip>
                            )}
                        </>
                    );
                }

                return <>{user}</>;
            }
        },
        {
            title: 'Date',
            width: 150,
            render: (record) => {
                return (
                    <span>{record?.createdAt ? dayjs(record?.createdAt).format('DD-MM-YYYY HH:mm:ss') : ''}</span>
                );
            }
        },
        {
            title: 'Action',
            key: 'action',
            align: 'right',
            width: 100,
            render: (text, record) => (
                <div>
                    <Tooltip title="View Details">
                        <EyeOutlined
                            style={{
                                fontSize: "24px",
                                cursor: "pointer",
                                marginRight: "5px",
                                color: "#006cb8",
                            }} onClick={() => {
                                    const hasedID = encodeId(record?.id)

                                navigate(`/transaction-transfer/${hasedID}`)}} />
                    </Tooltip>
                    

                </div>
            ),
        }

    ];

    return (
        <DataSheet>   
           <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}}/> Transfer Stock</>}
                style={{ marginBottom: '10px' }}
                extra={
                <>
                    <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF", }} onClick={() => navigate("/stocks/transfer-stock")} />
                </>
                }
            >
                <Row gutter={[6, 1]}>
                    <Col xs={24} md={12} lg={8}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
                        <RangePicker
                            style={{ width: '100%' }}
                            value={filters.dateRange}
                            onChange={(dates) => setFilters(prev => ({ ...prev, dateRange: dates }))}
                            format="DD-MM-YYYY"
                            allowClear={false}
                        />
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Search</label>
                        <Input
                            placeholder="Search"
                            value={filters.batchCode}
                            onChange={(e) => setFilters(prev => ({ ...prev, batchCode: e.target.value }))}
                        />
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <Space style={{ width: '100%', marginTop: '25px' }}>
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                            >
                                Search
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Card>

            <Table
                columns={columns}
                dataSource={allTransfers}
                pagination={false}
                scroll={{ x: 'max-content' }}
                rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
            />
        </DataSheet>
    );
};

export default TransferStockList;